'use client';

export function CookieSettingsButton() {
  return (
    <button
      className="block rounded-lg py-2 text-sm font-medium text-(--footer-link,hsl(var(--contrast-500))) ring-(--footer-focus,hsl(var(--primary))) transition-colors duration-300 hover:text-(--footer-link-hover,hsl(var(--foreground))) focus-visible:outline-0 focus-visible:ring-2"
      onClick={() => window.dispatchEvent(new CustomEvent('open-cookie-settings'))}
      type="button"
    >
      Cookie Settings
    </button>
  );
}
